module.exports = __webpack_public_path__ + "assets/img/ESPERADERECOGIDA.ffe64be9.svg";